import palette from './colors.json';

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export const colors = {
  [Theme.LIGHT]: {
    ...palette,
    // Interface Colors
    elevation0: palette.white,
    elevation1: palette.mono100,
    elevation2: palette.mono200,
    elevation3: palette.mono300,
    elevation4: palette.mono400,
    border: palette.mono300,
    borderMuted: 'rgba(0, 0, 0, 0.06)',
    // Typography
    text: palette.mono800,
    textBody: palette.mono750,
    textLight: palette.mono600,
    placeholder: palette.mono500,
    textInverted: palette.mono100,
    // Iconography
    icon: palette.mono800,
    inactive: palette.mono400,
    disclosure: palette.mono500,
    // States
    positive: palette.green,
    positiveL: palette.greenLight,
    positiveXL: palette.greenLightest,
    neutral: palette.blue,
    neutralL: palette.blueLight,
    neutralXL: palette.blueLightest,
    focus: palette.orange,
    focusL: palette.orangeLight,
    focusXL: palette.orangeLightest,
    negative: palette.red,
    negativeL: palette.redLight,
    negativeXL: palette.redLightest,
    // Custom
    popup: palette.white,
  },
  [Theme.DARK]: {
    ...palette,
    amberLight: '#4b3c10',
    amberLightest: '#332a10',
    blueLight: '#16344c',
    blueLightest: '#142736',
    cyanLight: '#0e3b41',
    cyanLightest: '#102a2d',
    deepOrangeLight: '#4b2316',
    deepOrangeLightest: '#331c14',
    deepPurple: '#7c4dff',
    deepPurpleDark: '#651fff',
    deepPurpleLight: '#2c1f44',
    deepPurpleLightest: '#231a32',
    greenLight: '#203821',
    greenLightest: '#1a281a',
    indigoLight: '#1d2139',
    indigoLightest: '#181d32',
    lightBlueLight: '#0f3648',
    lightBlueLightest: '#102732',
    lightGreenLight: '#303d20',
    lightGreenLightest: '#232b1a',
    limeLight: '#40431c',
    limeLightest: '#2c2e17',
    orangeLight: '#54370d',
    orangeLightest: '#3d2a0f',
    pinkLight: '#461526',
    pinkLightest: '#30131d',
    purpleLight: '#331738',
    purpleLightest: '#251528',
    redLight: '#57211d',
    redLightest: '#3f1b19',
    tealLight: '#0e322e',
    tealLightest: '#0f2422',
    yellowLight: '#4b461c',
    yellowLightest: '#343013',
    // Interface Colors
    elevation0: palette.black,
    elevation1: palette.mono900,
    elevation2: palette.mono850,
    elevation3: palette.mono800,
    elevation4: palette.mono750,
    border: palette.mono750,
    borderMuted: 'rgba(255, 255, 255, 0.06)',
    // Typography
    text: palette.mono100,
    textBody: palette.mono200,
    textLight: palette.mono400,
    placeholder: palette.mono500,
    textInverted: palette.mono800,
    // Iconography
    icon: palette.mono100,
    inactive: palette.mono600,
    disclosure: palette.mono400,
    // States
    positive: palette.greenDark,
    positiveL: '#203821',
    positiveXL: '#1a281a',
    neutral: palette.blueDark,
    neutralL: '#16344c',
    neutralXL: '#142736',
    focus: palette.orangeDark,
    focusL: '#54370d',
    focusXL: '#3d2a0f',
    negative: palette.redDark,
    negativeL: '#57211d',
    negativeXL: '#3f1b19',
    // Custom
    popup: palette.mono900,
  },
};

export type ThemeColors = (typeof colors)[Theme.LIGHT];
